import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import * as types from "../types";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {

    GetCallLogsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, callLogsFilters, onSuccess) => async (dispatch, store) => {
        if (pageSize < 0) {return onSuccess(null);}
        dispatch({ type: types.GET_CALLOGZONEID_UPDATED, payload: callLogsFilters.zoneId ? callLogsFilters.zoneId : null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/OrganizationCallLogs/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (callLogsFilters.zoneId ? "&zoneId=" + callLogsFilters.zoneId : "")
                + (callLogsFilters.callCenterId ? "&callCenterId=" + callLogsFilters.callCenterId : "")
                + (callLogsFilters.startDate ? "&startDate=" + callLogsFilters.startDate : "")
                + (callLogsFilters.endDate ? "&endDate=" + callLogsFilters.endDate : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    onRequestStatistics: (callCenterId, zoneId, startDate, endDate, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_DASHBOARDZONEID_UPDATED, payload: zoneId });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/ReportingResults/" + store().currentuser.currentorganization.id
        + "?zoneId=" + zoneId + "&startDate=" + startDate + "&endDate=" + endDate + (callCenterId || callCenterId === 0 ? "&callCenterId=" + callCenterId : "")
        , {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    onRequestStatisticsForAgent: (callCenterId, zoneId, startDate, endDate, agentId, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_DASHBOARDZONEID_UPDATED, payload: zoneId });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/ReportingResults/" + store().currentuser.currentorganization.id
        + "?zoneId=" + zoneId + "&agentId=" + agentId + "&startDate=" + startDate + "&endDate=" + endDate + (callCenterId || callCenterId === 0 ? "&callCenterId=" + callCenterId : "")
        , {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    onRequestStatisticsForClient: (callCenterId, zoneId, startDate, endDate, clientName, clientId, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_DASHBOARDZONEID_UPDATED, payload: zoneId });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/ReportingResults/" + store().currentuser.currentorganization.id
        + "?zoneId=" + zoneId + "&clientName=" + clientName + "&clientId=" + clientId + "&startDate=" + startDate + "&endDate=" + endDate + (callCenterId || callCenterId === 0 ? "&callCenterId=" + callCenterId : "")
        , {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    onRequestStatisticsAgents: (callCenterId, zoneId, startDate, endDate, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_DASHBOARDZONEID_UPDATED, payload: zoneId });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/ReportingResultsAgents/" + store().currentuser.currentorganization.id
        + "?zoneId=" + zoneId + "&startDate=" + startDate + "&endDate=" + endDate + (callCenterId || callCenterId === 0 ? "&callCenterId=" + callCenterId : "")
        , {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    onRequestStatisticsClients: (callCenterId, zoneId, startDate, endDate, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_DASHBOARDZONEID_UPDATED, payload: zoneId });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/ReportingResultsClients/" + store().currentuser.currentorganization.id
        + "?zoneId=" + zoneId + "&startDate=" + startDate + "&endDate=" + endDate + (callCenterId || callCenterId === 0 ? "&callCenterId=" + callCenterId : "")
        , {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    }
};
